/* AUTO-GENERATED by scripts/gen-char-meta.ts
   Uint16Array(65536) char meta table for BMP.
   - low 8 bits: char properties
   - high 8 bits: reserved for runtime trie flags (do not set here)
   Edit the generator, not this file.
*/

import { CM_LETTER, CM_NEWLINE, CM_NUMBER, CM_SURROGATE, CM_WS, CM_WS_COLLAPSABLE } from "./char-meta-flags";

type Range = readonly [start: number, endInclusive: number, value: number];

const RANGES: readonly Range[] = [
	[0x0000, 0x0008, 0], // Space / control
	[0x0009, 0x0009, CM_WS | CM_WS_COLLAPSABLE], // Space / control
	[0x000a, 0x000d, CM_WS | CM_WS_COLLAPSABLE | CM_NEWLINE], // Space / control
	[0x000e, 0x001f, 0], // Space / control
	[0x0020, 0x0020, CM_WS | CM_WS_COLLAPSABLE], // Space / control
	[0x0021, 0x002f, 0],
	[0x0030, 0x0039, CM_NUMBER], // ASCII digit
	[0x003a, 0x0040, 0],
	[0x0041, 0x005a, CM_LETTER], // ASCII uppercase
	[0x005b, 0x0060, 0],
	[0x0061, 0x007a, CM_LETTER], // ASCII lowercase
	[0x007b, 0x009f, 0],
	[0x00a0, 0x00a0, CM_WS],
	[0x00a1, 0x00a9, 0],
	[0x00aa, 0x00aa, CM_LETTER],
	[0x00ab, 0x00b1, 0],
	[0x00b2, 0x00b3, CM_NUMBER],
	[0x00b4, 0x00b4, 0],
	[0x00b5, 0x00b5, CM_LETTER],
	[0x00b6, 0x00b8, 0],
	[0x00b9, 0x00b9, CM_NUMBER],
	[0x00ba, 0x00ba, CM_LETTER],
	[0x00bb, 0x00bb, 0],
	[0x00bc, 0x00be, CM_NUMBER],
	[0x00bf, 0x00bf, 0],
	[0x00c0, 0x00d6, CM_LETTER],
	[0x00d7, 0x00d7, 0],
	[0x00d8, 0x00f6, CM_LETTER],
	[0x00f7, 0x00f7, 0],
	[0x00f8, 0x02c1, CM_LETTER],
	[0x02c2, 0x02c5, 0],
	[0x02c6, 0x02d1, CM_LETTER],
	[0x02d2, 0x02df, 0],
	[0x02e0, 0x02e4, CM_LETTER],
	[0x02e5, 0x02eb, 0],
	[0x02ec, 0x02ec, CM_LETTER],
	[0x02ed, 0x02ed, 0],
	[0x02ee, 0x02ee, CM_LETTER],
	[0x02ef, 0x02ff, 0],
	[0x0300, 0x0374, CM_LETTER],
	[0x0375, 0x0375, 0],
	[0x0376, 0x0377, CM_LETTER],
	[0x0378, 0x0379, 0],
	[0x037a, 0x037d, CM_LETTER],
	[0x037e, 0x037e, 0],
	[0x037f, 0x037f, CM_LETTER],
	[0x0380, 0x0385, 0],
	[0x0386, 0x0386, CM_LETTER],
	[0x0387, 0x0387, 0],
	[0x0388, 0x038a, CM_LETTER],
	[0x038b, 0x038b, 0],
	[0x038c, 0x038c, CM_LETTER],
	[0x038d, 0x038d, 0],
	[0x038e, 0x03a1, CM_LETTER],
	[0x03a2, 0x03a2, 0],
	[0x03a3, 0x03f5, CM_LETTER],
	[0x03f6, 0x03f6, 0],
	[0x03f7, 0x0481, CM_LETTER],
	[0x0482, 0x0482, 0],
	[0x0483, 0x052f, CM_LETTER],
	[0x0530, 0x0530, 0],
	[0x0531, 0x0556, CM_LETTER],
	[0x0557, 0x0558, 0],
	[0x0559, 0x0559, CM_LETTER],
	[0x055a, 0x055f, 0],
	[0x0560, 0x0588, CM_LETTER],
	[0x0589, 0x0590, 0],
	[0x0591, 0x05bd, CM_LETTER],
	[0x05be, 0x05be, 0],
	[0x05bf, 0x05bf, CM_LETTER],
	[0x05c0, 0x05c0, 0],
	[0x05c1, 0x05c2, CM_LETTER],
	[0x05c3, 0x05c3, 0],
	[0x05c4, 0x05c5, CM_LETTER],
	[0x05c6, 0x05c6, 0],
	[0x05c7, 0x05c7, CM_LETTER],
	[0x05c8, 0x05cf, 0],
	[0x05d0, 0x05ea, CM_LETTER],
	[0x05eb, 0x05ee, 0],
	[0x05ef, 0x05f2, CM_LETTER],
	[0x05f3, 0x060f, 0],
	[0x0610, 0x061a, CM_LETTER],
	[0x061b, 0x061f, 0],
	[0x0620, 0x065f, CM_LETTER],
	[0x0660, 0x0669, CM_NUMBER],
	[0x066a, 0x066d, 0],
	[0x066e, 0x06d3, CM_LETTER],
	[0x06d4, 0x06d4, 0],
	[0x06d5, 0x06dc, CM_LETTER],
	[0x06dd, 0x06de, 0],
	[0x06df, 0x06e8, CM_LETTER],
	[0x06e9, 0x06e9, 0],
	[0x06ea, 0x06ef, CM_LETTER],
	[0x06f0, 0x06f9, CM_NUMBER],
	[0x06fa, 0x06fc, CM_LETTER],
	[0x06fd, 0x06fe, 0],
	[0x06ff, 0x06ff, CM_LETTER],
	[0x0700, 0x070f, 0],
	[0x0710, 0x074a, CM_LETTER],
	[0x074b, 0x074c, 0],
	[0x074d, 0x07b1, CM_LETTER],
	[0x07b2, 0x07bf, 0],
	[0x07c0, 0x07c9, CM_NUMBER],
	[0x07ca, 0x07f5, CM_LETTER],
	[0x07f6, 0x07f9, 0],
	[0x07fa, 0x07fa, CM_LETTER],
	[0x07fb, 0x07fc, 0],
	[0x07fd, 0x07fd, CM_LETTER],
	[0x07fe, 0x07ff, 0],
	[0x0800, 0x082d, CM_LETTER],
	[0x082e, 0x083f, 0],
	[0x0840, 0x085b, CM_LETTER],
	[0x085c, 0x085f, 0],
	[0x0860, 0x086a, CM_LETTER],
	[0x086b, 0x086f, 0],
	[0x0870, 0x0887, CM_LETTER],
	[0x0888, 0x0888, 0],
	[0x0889, 0x088f, CM_LETTER],
	[0x0890, 0x0896, 0],
	[0x0897, 0x08e1, CM_LETTER],
	[0x08e2, 0x08e2, 0],
	[0x08e3, 0x0963, CM_LETTER],
	[0x0964, 0x0965, 0],
	[0x0966, 0x096f, CM_NUMBER],
	[0x0970, 0x0970, 0],
	[0x0971, 0x0983, CM_LETTER],
	[0x0984, 0x0984, 0],
	[0x0985, 0x098c, CM_LETTER],
	[0x098d, 0x098e, 0],
	[0x098f, 0x0990, CM_LETTER],
	[0x0991, 0x0992, 0],
	[0x0993, 0x09a8, CM_LETTER],
	[0x09a9, 0x09a9, 0],
	[0x09aa, 0x09b0, CM_LETTER],
	[0x09b1, 0x09b1, 0],
	[0x09b2, 0x09b2, CM_LETTER],
	[0x09b3, 0x09b5, 0],
	[0x09b6, 0x09b9, CM_LETTER],
	[0x09ba, 0x09bb, 0],
	[0x09bc, 0x09c4, CM_LETTER],
	[0x09c5, 0x09c6, 0],
	[0x09c7, 0x09c8, CM_LETTER],
	[0x09c9, 0x09ca, 0],
	[0x09cb, 0x09ce, CM_LETTER],
	[0x09cf, 0x09d6, 0],
	[0x09d7, 0x09d7, CM_LETTER],
	[0x09d8, 0x09db, 0],
	[0x09dc, 0x09dd, CM_LETTER],
	[0x09de, 0x09de, 0],
	[0x09df, 0x09e3, CM_LETTER],
	[0x09e4, 0x09e5, 0],
	[0x09e6, 0x09ef, CM_NUMBER],
	[0x09f0, 0x09f1, CM_LETTER],
	[0x09f2, 0x09f3, 0],
	[0x09f4, 0x09f9, CM_NUMBER],
	[0x09fa, 0x09fb, 0],
	[0x09fc, 0x09fc, CM_LETTER],
	[0x09fd, 0x09fd, 0],
	[0x09fe, 0x09fe, CM_LETTER],
	[0x09ff, 0x0a00, 0],
	[0x0a01, 0x0a03, CM_LETTER],
	[0x0a04, 0x0a04, 0],
	[0x0a05, 0x0a0a, CM_LETTER],
	[0x0a0b, 0x0a0e, 0],
	[0x0a0f, 0x0a10, CM_LETTER],
	[0x0a11, 0x0a12, 0],
	[0x0a13, 0x0a28, CM_LETTER],
	[0x0a29, 0x0a29, 0],
	[0x0a2a, 0x0a30, CM_LETTER],
	[0x0a31, 0x0a31, 0],
	[0x0a32, 0x0a33, CM_LETTER],
	[0x0a34, 0x0a34, 0],
	[0x0a35, 0x0a36, CM_LETTER],
	[0x0a37, 0x0a37, 0],
	[0x0a38, 0x0a39, CM_LETTER],
	[0x0a3a, 0x0a3b, 0],
	[0x0a3c, 0x0a3c, CM_LETTER],
	[0x0a3d, 0x0a3d, 0],
	[0x0a3e, 0x0a42, CM_LETTER],
	[0x0a43, 0x0a46, 0],
	[0x0a47, 0x0a48, CM_LETTER],
	[0x0a49, 0x0a4a, 0],
	[0x0a4b, 0x0a4d, CM_LETTER],
	[0x0a4e, 0x0a50, 0],
	[0x0a51, 0x0a51, CM_LETTER],
	[0x0a52, 0x0a58, 0],
	[0x0a59, 0x0a5c, CM_LETTER],
	[0x0a5d, 0x0a5d, 0],
	[0x0a5e, 0x0a5e, CM_LETTER],
	[0x0a5f, 0x0a65, 0],
	[0x0a66, 0x0a6f, CM_NUMBER],
	[0x0a70, 0x0a75, CM_LETTER],
	[0x0a76, 0x0a80, 0],
	[0x0a81, 0x0a83, CM_LETTER],
	[0x0a84, 0x0a84, 0],
	[0x0a85, 0x0a8d, CM_LETTER],
	[0x0a8e, 0x0a8e, 0],
	[0x0a8f, 0x0a91, CM_LETTER],
	[0x0a92, 0x0a92, 0],
	[0x0a93, 0x0aa8, CM_LETTER],
	[0x0aa9, 0x0aa9, 0],
	[0x0aaa, 0x0ab0, CM_LETTER],
	[0x0ab1, 0x0ab1, 0],
	[0x0ab2, 0x0ab3, CM_LETTER],
	[0x0ab4, 0x0ab4, 0],
	[0x0ab5, 0x0ab9, CM_LETTER],
	[0x0aba, 0x0abb, 0],
	[0x0abc, 0x0ac5, CM_LETTER],
	[0x0ac6, 0x0ac6, 0],
	[0x0ac7, 0x0ac9, CM_LETTER],
	[0x0aca, 0x0aca, 0],
	[0x0acb, 0x0acd, CM_LETTER],
	[0x0ace, 0x0acf, 0],
	[0x0ad0, 0x0ad0, CM_LETTER],
	[0x0ad1, 0x0adf, 0],
	[0x0ae0, 0x0ae3, CM_LETTER],
	[0x0ae4, 0x0ae5, 0],
	[0x0ae6, 0x0aef, CM_NUMBER],
	[0x0af0, 0x0af8, 0],
	[0x0af9, 0x0aff, CM_LETTER],
	[0x0b00, 0x0b00, 0],
	[0x0b01, 0x0b03, CM_LETTER],
	[0x0b04, 0x0b04, 0],
	[0x0b05, 0x0b0c, CM_LETTER],
	[0x0b0d, 0x0b0e, 0],
	[0x0b0f, 0x0b10, CM_LETTER],
	[0x0b11, 0x0b12, 0],
	[0x0b13, 0x0b28, CM_LETTER],
	[0x0b29, 0x0b29, 0],
	[0x0b2a, 0x0b30, CM_LETTER],
	[0x0b31, 0x0b31, 0],
	[0x0b32, 0x0b33, CM_LETTER],
	[0x0b34, 0x0b34, 0],
	[0x0b35, 0x0b39, CM_LETTER],
	[0x0b3a, 0x0b3b, 0],
	[0x0b3c, 0x0b44, CM_LETTER],
	[0x0b45, 0x0b46, 0],
	[0x0b47, 0x0b48, CM_LETTER],
	[0x0b49, 0x0b4a, 0],
	[0x0b4b, 0x0b4d, CM_LETTER],
	[0x0b4e, 0x0b54, 0],
	[0x0b55, 0x0b57, CM_LETTER],
	[0x0b58, 0x0b5b, 0],
	[0x0b5c, 0x0b5d, CM_LETTER],
	[0x0b5e, 0x0b5e, 0],
	[0x0b5f, 0x0b63, CM_LETTER],
	[0x0b64, 0x0b65, 0],
	[0x0b66, 0x0b6f, CM_NUMBER],
	[0x0b70, 0x0b70, 0],
	[0x0b71, 0x0b71, CM_LETTER],
	[0x0b72, 0x0b77, CM_NUMBER],
	[0x0b78, 0x0b81, 0],
	[0x0b82, 0x0b83, CM_LETTER],
	[0x0b84, 0x0b84, 0],
	[0x0b85, 0x0b8a, CM_LETTER],
	[0x0b8b, 0x0b8d, 0],
	[0x0b8e, 0x0b90, CM_LETTER],
	[0x0b91, 0x0b91, 0],
	[0x0b92, 0x0b95, CM_LETTER],
	[0x0b96, 0x0b98, 0],
	[0x0b99, 0x0b9a, CM_LETTER],
	[0x0b9b, 0x0b9b, 0],
	[0x0b9c, 0x0b9c, CM_LETTER],
	[0x0b9d, 0x0b9d, 0],
	[0x0b9e, 0x0b9f, CM_LETTER],
	[0x0ba0, 0x0ba2, 0],
	[0x0ba3, 0x0ba4, CM_LETTER],
	[0x0ba5, 0x0ba7, 0],
	[0x0ba8, 0x0baa, CM_LETTER],
	[0x0bab, 0x0bad, 0],
	[0x0bae, 0x0bb9, CM_LETTER],
	[0x0bba, 0x0bbd, 0],
	[0x0bbe, 0x0bc2, CM_LETTER],
	[0x0bc3, 0x0bc5, 0],
	[0x0bc6, 0x0bc8, CM_LETTER],
	[0x0bc9, 0x0bc9, 0],
	[0x0bca, 0x0bcd, CM_LETTER],
	[0x0bce, 0x0bcf, 0],
	[0x0bd0, 0x0bd0, CM_LETTER],
	[0x0bd1, 0x0bd6, 0],
	[0x0bd7, 0x0bd7, CM_LETTER],
	[0x0bd8, 0x0be5, 0],
	[0x0be6, 0x0bf2, CM_NUMBER],
	[0x0bf3, 0x0bff, 0],
	[0x0c00, 0x0c0c, CM_LETTER],
	[0x0c0d, 0x0c0d, 0],
	[0x0c0e, 0x0c10, CM_LETTER],
	[0x0c11, 0x0c11, 0],
	[0x0c12, 0x0c28, CM_LETTER],
	[0x0c29, 0x0c29, 0],
	[0x0c2a, 0x0c39, CM_LETTER],
	[0x0c3a, 0x0c3b, 0],
	[0x0c3c, 0x0c44, CM_LETTER],
	[0x0c45, 0x0c45, 0],
	[0x0c46, 0x0c48, CM_LETTER],
	[0x0c49, 0x0c49, 0],
	[0x0c4a, 0x0c4d, CM_LETTER],
	[0x0c4e, 0x0c54, 0],
	[0x0c55, 0x0c56, CM_LETTER],
	[0x0c57, 0x0c57, 0],
	[0x0c58, 0x0c5a, CM_LETTER],
	[0x0c5b, 0x0c5b, 0],
	[0x0c5c, 0x0c5d, CM_LETTER],
	[0x0c5e, 0x0c5f, 0],
	[0x0c60, 0x0c63, CM_LETTER],
	[0x0c64, 0x0c65, 0],
	[0x0c66, 0x0c6f, CM_NUMBER],
	[0x0c70, 0x0c77, 0],
	[0x0c78, 0x0c7e, CM_NUMBER],
	[0x0c7f, 0x0c7f, 0],
	[0x0c80, 0x0c83, CM_LETTER],
	[0x0c84, 0x0c84, 0],
	[0x0c85, 0x0c8c, CM_LETTER],
	[0x0c8d, 0x0c8d, 0],
	[0x0c8e, 0x0c90, CM_LETTER],
	[0x0c91, 0x0c91, 0],
	[0x0c92, 0x0ca8, CM_LETTER],
	[0x0ca9, 0x0ca9, 0],
	[0x0caa, 0x0cb3, CM_LETTER],
	[0x0cb4, 0x0cb4, 0],
	[0x0cb5, 0x0cb9, CM_LETTER],
	[0x0cba, 0x0cbb, 0],
	[0x0cbc, 0x0cc4, CM_LETTER],
	[0x0cc5, 0x0cc5, 0],
	[0x0cc6, 0x0cc8, CM_LETTER],
	[0x0cc9, 0x0cc9, 0],
	[0x0cca, 0x0ccd, CM_LETTER],
	[0x0cce, 0x0cd4, 0],
	[0x0cd5, 0x0cd6, CM_LETTER],
	[0x0cd7, 0x0cdb, 0],
	[0x0cdc, 0x0cde, CM_LETTER],
	[0x0cdf, 0x0cdf, 0],
	[0x0ce0, 0x0ce3, CM_LETTER],
	[0x0ce4, 0x0ce5, 0],
	[0x0ce6, 0x0cef, CM_NUMBER],
	[0x0cf0, 0x0cf0, 0],
	[0x0cf1, 0x0cf3, CM_LETTER],
	[0x0cf4, 0x0cff, 0],
	[0x0d00, 0x0d0c, CM_LETTER],
	[0x0d0d, 0x0d0d, 0],
	[0x0d0e, 0x0d10, CM_LETTER],
	[0x0d11, 0x0d11, 0],
	[0x0d12, 0x0d44, CM_LETTER],
	[0x0d45, 0x0d45, 0],
	[0x0d46, 0x0d48, CM_LETTER],
	[0x0d49, 0x0d49, 0],
	[0x0d4a, 0x0d4e, CM_LETTER],
	[0x0d4f, 0x0d53, 0],
	[0x0d54, 0x0d57, CM_LETTER],
	[0x0d58, 0x0d5e, CM_NUMBER],
	[0x0d5f, 0x0d63, CM_LETTER],
	[0x0d64, 0x0d65, 0],
	[0x0d66, 0x0d78, CM_NUMBER],
	[0x0d79, 0x0d79, 0],
	[0x0d7a, 0x0d7f, CM_LETTER],
	[0x0d80, 0x0d80, 0],
	[0x0d81, 0x0d83, CM_LETTER],
	[0x0d84, 0x0d84, 0],
	[0x0d85, 0x0d96, CM_LETTER],
	[0x0d97, 0x0d99, 0],
	[0x0d9a, 0x0db1, CM_LETTER],
	[0x0db2, 0x0db2, 0],
	[0x0db3, 0x0dbb, CM_LETTER],
	[0x0dbc, 0x0dbc, 0],
	[0x0dbd, 0x0dbd, CM_LETTER],
	[0x0dbe, 0x0dbf, 0],
	[0x0dc0, 0x0dc6, CM_LETTER],
	[0x0dc7, 0x0dc9, 0],
	[0x0dca, 0x0dca, CM_LETTER],
	[0x0dcb, 0x0dce, 0],
	[0x0dcf, 0x0dd4, CM_LETTER],
	[0x0dd5, 0x0dd5, 0],
	[0x0dd6, 0x0dd6, CM_LETTER],
	[0x0dd7, 0x0dd7, 0],
	[0x0dd8, 0x0ddf, CM_LETTER],
	[0x0de0, 0x0de5, 0],
	[0x0de6, 0x0def, CM_NUMBER],
	[0x0df0, 0x0df1, 0],
	[0x0df2, 0x0df3, CM_LETTER],
	[0x0df4, 0x0e00, 0],
	[0x0e01, 0x0e3a, CM_LETTER],
	[0x0e3b, 0x0e3f, 0],
	[0x0e40, 0x0e4e, CM_LETTER],
	[0x0e4f, 0x0e4f, 0],
	[0x0e50, 0x0e59, CM_NUMBER],
	[0x0e5a, 0x0e80, 0],
	[0x0e81, 0x0e82, CM_LETTER],
	[0x0e83, 0x0e83, 0],
	[0x0e84, 0x0e84, CM_LETTER],
	[0x0e85, 0x0e85, 0],
	[0x0e86, 0x0e8a, CM_LETTER],
	[0x0e8b, 0x0e8b, 0],
	[0x0e8c, 0x0ea3, CM_LETTER],
	[0x0ea4, 0x0ea4, 0],
	[0x0ea5, 0x0ea5, CM_LETTER],
	[0x0ea6, 0x0ea6, 0],
	[0x0ea7, 0x0ebd, CM_LETTER],
	[0x0ebe, 0x0ebf, 0],
	[0x0ec0, 0x0ec4, CM_LETTER],
	[0x0ec5, 0x0ec5, 0],
	[0x0ec6, 0x0ec6, CM_LETTER],
	[0x0ec7, 0x0ec7, 0],
	[0x0ec8, 0x0ece, CM_LETTER],
	[0x0ecf, 0x0ecf, 0],
	[0x0ed0, 0x0ed9, CM_NUMBER],
	[0x0eda, 0x0edb, 0],
	[0x0edc, 0x0edf, CM_LETTER],
	[0x0ee0, 0x0eff, 0],
	[0x0f00, 0x0f00, CM_LETTER],
	[0x0f01, 0x0f17, 0],
	[0x0f18, 0x0f19, CM_LETTER],
	[0x0f1a, 0x0f1f, 0],
	[0x0f20, 0x0f33, CM_NUMBER],
	[0x0f34, 0x0f34, 0],
	[0x0f35, 0x0f35, CM_LETTER],
	[0x0f36, 0x0f36, 0],
	[0x0f37, 0x0f37, CM_LETTER],
	[0x0f38, 0x0f38, 0],
	[0x0f39, 0x0f39, CM_LETTER],
	[0x0f3a, 0x0f3d, 0],
	[0x0f3e, 0x0f47, CM_LETTER],
	[0x0f48, 0x0f48, 0],
	[0x0f49, 0x0f6c, CM_LETTER],
	[0x0f6d, 0x0f70, 0],
	[0x0f71, 0x0f84, CM_LETTER],
	[0x0f85, 0x0f85, 0],
	[0x0f86, 0x0f97, CM_LETTER],
	[0x0f98, 0x0f98, 0],
	[0x0f99, 0x0fbc, CM_LETTER],
	[0x0fbd, 0x0fc5, 0],
	[0x0fc6, 0x0fc6, CM_LETTER],
	[0x0fc7, 0x0fff, 0],
	[0x1000, 0x103f, CM_LETTER],
	[0x1040, 0x1049, CM_NUMBER],
	[0x104a, 0x104f, 0],
	[0x1050, 0x108f, CM_LETTER],
	[0x1090, 0x1099, CM_NUMBER],
	[0x109a, 0x109d, CM_LETTER],
	[0x109e, 0x109f, 0],
	[0x10a0, 0x10c5, CM_LETTER],
	[0x10c6, 0x10c6, 0],
	[0x10c7, 0x10c7, CM_LETTER],
	[0x10c8, 0x10cc, 0],
	[0x10cd, 0x10cd, CM_LETTER],
	[0x10ce, 0x10cf, 0],
	[0x10d0, 0x10fa, CM_LETTER],
	[0x10fb, 0x10fb, 0],
	[0x10fc, 0x1248, CM_LETTER],
	[0x1249, 0x1249, 0],
	[0x124a, 0x124d, CM_LETTER],
	[0x124e, 0x124f, 0],
	[0x1250, 0x1256, CM_LETTER],
	[0x1257, 0x1257, 0],
	[0x1258, 0x1258, CM_LETTER],
	[0x1259, 0x1259, 0],
	[0x125a, 0x125d, CM_LETTER],
	[0x125e, 0x125f, 0],
	[0x1260, 0x1288, CM_LETTER],
	[0x1289, 0x1289, 0],
	[0x128a, 0x128d, CM_LETTER],
	[0x128e, 0x128f, 0],
	[0x1290, 0x12b0, CM_LETTER],
	[0x12b1, 0x12b1, 0],
	[0x12b2, 0x12b5, CM_LETTER],
	[0x12b6, 0x12b7, 0],
	[0x12b8, 0x12be, CM_LETTER],
	[0x12bf, 0x12bf, 0],
	[0x12c0, 0x12c0, CM_LETTER],
	[0x12c1, 0x12c1, 0],
	[0x12c2, 0x12c5, CM_LETTER],
	[0x12c6, 0x12c7, 0],
	[0x12c8, 0x12d6, CM_LETTER],
	[0x12d7, 0x12d7, 0],
	[0x12d8, 0x1310, CM_LETTER],
	[0x1311, 0x1311, 0],
	[0x1312, 0x1315, CM_LETTER],
	[0x1316, 0x1317, 0],
	[0x1318, 0x135a, CM_LETTER],
	[0x135b, 0x135c, 0],
	[0x135d, 0x135f, CM_LETTER],
	[0x1360, 0x1368, 0],
	[0x1369, 0x137c, CM_NUMBER],
	[0x137d, 0x137f, 0],
	[0x1380, 0x138f, CM_LETTER],
	[0x1390, 0x139f, 0],
	[0x13a0, 0x13f5, CM_LETTER],
	[0x13f6, 0x13f7, 0],
	[0x13f8, 0x13fd, CM_LETTER],
	[0x13fe, 0x1400, 0],
	[0x1401, 0x166c, CM_LETTER],
	[0x166d, 0x166e, 0],
	[0x166f, 0x167f, CM_LETTER],
	[0x1680, 0x1680, CM_WS | CM_WS_COLLAPSABLE],
	[0x1681, 0x169a, CM_LETTER],
	[0x169b, 0x169f, 0],
	[0x16a0, 0x16ea, CM_LETTER],
	[0x16eb, 0x16ed, 0],
	[0x16ee, 0x16f0, CM_NUMBER],
	[0x16f1, 0x16f8, CM_LETTER],
	[0x16f9, 0x16ff, 0],
	[0x1700, 0x1715, CM_LETTER],
	[0x1716, 0x171e, 0],
	[0x171f, 0x1734, CM_LETTER],
	[0x1735, 0x173f, 0],
	[0x1740, 0x1753, CM_LETTER],
	[0x1754, 0x175f, 0],
	[0x1760, 0x176c, CM_LETTER],
	[0x176d, 0x176d, 0],
	[0x176e, 0x1770, CM_LETTER],
	[0x1771, 0x1771, 0],
	[0x1772, 0x1773, CM_LETTER],
	[0x1774, 0x177f, 0],
	[0x1780, 0x17d3, CM_LETTER],
	[0x17d4, 0x17d6, 0],
	[0x17d7, 0x17d7, CM_LETTER],
	[0x17d8, 0x17db, 0],
	[0x17dc, 0x17dd, CM_LETTER],
	[0x17de, 0x17df, 0],
	[0x17e0, 0x17e9, CM_NUMBER],
	[0x17ea, 0x17ef, 0],
	[0x17f0, 0x17f9, CM_NUMBER],
	[0x17fa, 0x180a, 0],
	[0x180b, 0x180d, CM_LETTER],
	[0x180e, 0x180e, 0],
	[0x180f, 0x180f, CM_LETTER],
	[0x1810, 0x1819, CM_NUMBER],
	[0x181a, 0x181f, 0],
	[0x1820, 0x1878, CM_LETTER],
	[0x1879, 0x187f, 0],
	[0x1880, 0x18aa, CM_LETTER],
	[0x18ab, 0x18af, 0],
	[0x18b0, 0x18f5, CM_LETTER],
	[0x18f6, 0x18ff, 0],
	[0x1900, 0x191e, CM_LETTER],
	[0x191f, 0x191f, 0],
	[0x1920, 0x192b, CM_LETTER],
	[0x192c, 0x192f, 0],
	[0x1930, 0x193b, CM_LETTER],
	[0x193c, 0x1945, 0],
	[0x1946, 0x194f, CM_NUMBER],
	[0x1950, 0x196d, CM_LETTER],
	[0x196e, 0x196f, 0],
	[0x1970, 0x1974, CM_LETTER],
	[0x1975, 0x197f, 0],
	[0x1980, 0x19ab, CM_LETTER],
	[0x19ac, 0x19af, 0],
	[0x19b0, 0x19c9, CM_LETTER],
	[0x19ca, 0x19cf, 0],
	[0x19d0, 0x19da, CM_NUMBER],
	[0x19db, 0x19ff, 0],
	[0x1a00, 0x1a1b, CM_LETTER],
	[0x1a1c, 0x1a1f, 0],
	[0x1a20, 0x1a5e, CM_LETTER],
	[0x1a5f, 0x1a5f, 0],
	[0x1a60, 0x1a7c, CM_LETTER],
	[0x1a7d, 0x1a7e, 0],
	[0x1a7f, 0x1a7f, CM_LETTER],
	[0x1a80, 0x1a89, CM_NUMBER],
	[0x1a8a, 0x1a8f, 0],
	[0x1a90, 0x1a99, CM_NUMBER],
	[0x1a9a, 0x1aa6, 0],
	[0x1aa7, 0x1aa7, CM_LETTER],
	[0x1aa8, 0x1aaf, 0],
	[0x1ab0, 0x1add, CM_LETTER],
	[0x1ade, 0x1adf, 0],
	[0x1ae0, 0x1aeb, CM_LETTER],
	[0x1aec, 0x1aff, 0],
	[0x1b00, 0x1b4c, CM_LETTER],
	[0x1b4d, 0x1b4f, 0],
	[0x1b50, 0x1b59, CM_NUMBER],
	[0x1b5a, 0x1b6a, 0],
	[0x1b6b, 0x1b73, CM_LETTER],
	[0x1b74, 0x1b7f, 0],
	[0x1b80, 0x1baf, CM_LETTER],
	[0x1bb0, 0x1bb9, CM_NUMBER],
	[0x1bba, 0x1bf3, CM_LETTER],
	[0x1bf4, 0x1bff, 0],
	[0x1c00, 0x1c37, CM_LETTER],
	[0x1c38, 0x1c3f, 0],
	[0x1c40, 0x1c49, CM_NUMBER],
	[0x1c4a, 0x1c4c, 0],
	[0x1c4d, 0x1c4f, CM_LETTER],
	[0x1c50, 0x1c59, CM_NUMBER],
	[0x1c5a, 0x1c7d, CM_LETTER],
	[0x1c7e, 0x1c7f, 0],
	[0x1c80, 0x1c8a, CM_LETTER],
	[0x1c8b, 0x1c8f, 0],
	[0x1c90, 0x1cba, CM_LETTER],
	[0x1cbb, 0x1cbc, 0],
	[0x1cbd, 0x1cbf, CM_LETTER],
	[0x1cc0, 0x1ccf, 0],
	[0x1cd0, 0x1cd2, CM_LETTER],
	[0x1cd3, 0x1cd3, 0],
	[0x1cd4, 0x1cfa, CM_LETTER],
	[0x1cfb, 0x1cff, 0],
	[0x1d00, 0x1f15, CM_LETTER],
	[0x1f16, 0x1f17, 0],
	[0x1f18, 0x1f1d, CM_LETTER],
	[0x1f1e, 0x1f1f, 0],
	[0x1f20, 0x1f45, CM_LETTER],
	[0x1f46, 0x1f47, 0],
	[0x1f48, 0x1f4d, CM_LETTER],
	[0x1f4e, 0x1f4f, 0],
	[0x1f50, 0x1f57, CM_LETTER],
	[0x1f58, 0x1f58, 0],
	[0x1f59, 0x1f59, CM_LETTER],
	[0x1f5a, 0x1f5a, 0],
	[0x1f5b, 0x1f5b, CM_LETTER],
	[0x1f5c, 0x1f5c, 0],
	[0x1f5d, 0x1f5d, CM_LETTER],
	[0x1f5e, 0x1f5e, 0],
	[0x1f5f, 0x1f7d, CM_LETTER],
	[0x1f7e, 0x1f7f, 0],
	[0x1f80, 0x1fb4, CM_LETTER],
	[0x1fb5, 0x1fb5, 0],
	[0x1fb6, 0x1fbc, CM_LETTER],
	[0x1fbd, 0x1fbd, 0],
	[0x1fbe, 0x1fbe, CM_LETTER],
	[0x1fbf, 0x1fc1, 0],
	[0x1fc2, 0x1fc4, CM_LETTER],
	[0x1fc5, 0x1fc5, 0],
	[0x1fc6, 0x1fcc, CM_LETTER],
	[0x1fcd, 0x1fcf, 0],
	[0x1fd0, 0x1fd3, CM_LETTER],
	[0x1fd4, 0x1fd5, 0],
	[0x1fd6, 0x1fdb, CM_LETTER],
	[0x1fdc, 0x1fdf, 0],
	[0x1fe0, 0x1fec, CM_LETTER],
	[0x1fed, 0x1ff1, 0],
	[0x1ff2, 0x1ff4, CM_LETTER],
	[0x1ff5, 0x1ff5, 0],
	[0x1ff6, 0x1ffc, CM_LETTER],
	[0x1ffd, 0x1fff, 0],
	[0x2000, 0x200a, CM_WS | CM_WS_COLLAPSABLE],
	[0x200b, 0x2027, 0],
	[0x2028, 0x2029, CM_WS | CM_WS_COLLAPSABLE | CM_NEWLINE],
	[0x202a, 0x202e, 0],
	[0x202f, 0x202f, CM_WS | CM_WS_COLLAPSABLE],
	[0x2030, 0x203e, 0],
	[0x203f, 0x2040, CM_LETTER],
	[0x2041, 0x2053, 0],
	[0x2054, 0x2054, CM_LETTER],
	[0x2055, 0x205e, 0],
	[0x205f, 0x205f, CM_WS | CM_WS_COLLAPSABLE],
	[0x2060, 0x206f, 0],
	[0x2070, 0x2070, CM_NUMBER],
	[0x2071, 0x2071, CM_LETTER],
	[0x2072, 0x2073, 0],
	[0x2074, 0x2079, CM_NUMBER],
	[0x207a, 0x207e, 0],
	[0x207f, 0x207f, CM_LETTER],
	[0x2080, 0x2089, CM_NUMBER],
	[0x208a, 0x208f, 0],
	[0x2090, 0x209c, CM_LETTER],
	[0x209d, 0x20cf, 0],
	[0x20d0, 0x20f0, CM_LETTER],
	[0x20f1, 0x2101, 0],
	[0x2102, 0x2102, CM_LETTER],
	[0x2103, 0x2106, 0],
	[0x2107, 0x2107, CM_LETTER],
	[0x2108, 0x2109, 0],
	[0x210a, 0x2113, CM_LETTER],
	[0x2114, 0x2114, 0],
	[0x2115, 0x2115, CM_LETTER],
	[0x2116, 0x2118, 0],
	[0x2119, 0x211d, CM_LETTER],
	[0x211e, 0x2123, 0],
	[0x2124, 0x2124, CM_LETTER],
	[0x2125, 0x2125, 0],
	[0x2126, 0x2126, CM_LETTER],
	[0x2127, 0x2127, 0],
	[0x2128, 0x2128, CM_LETTER],
	[0x2129, 0x2129, 0],
	[0x212a, 0x212d, CM_LETTER],
	[0x212e, 0x212e, 0],
	[0x212f, 0x2139, CM_LETTER],
	[0x213a, 0x213b, 0],
	[0x213c, 0x213f, CM_LETTER],
	[0x2140, 0x2144, 0],
	[0x2145, 0x2149, CM_LETTER],
	[0x214a, 0x214d, 0],
	[0x214e, 0x214e, CM_LETTER],
	[0x214f, 0x214f, 0],
	[0x2150, 0x2182, CM_NUMBER],
	[0x2183, 0x2184, CM_LETTER],
	[0x2185, 0x2189, CM_NUMBER],
	[0x218a, 0x245f, 0],
	[0x2460, 0x249b, CM_NUMBER],
	[0x249c, 0x24e9, 0],
	[0x24ea, 0x24ff, CM_NUMBER],
	[0x2500, 0x2775, 0],
	[0x2776, 0x2793, CM_NUMBER],
	[0x2794, 0x2bff, 0],
	[0x2c00, 0x2ce4, CM_LETTER],
	[0x2ce5, 0x2cea, 0],
	[0x2ceb, 0x2cf3, CM_LETTER],
	[0x2cf4, 0x2cfc, 0],
	[0x2cfd, 0x2cfd, CM_NUMBER],
	[0x2cfe, 0x2cff, 0],
	[0x2d00, 0x2d25, CM_LETTER],
	[0x2d26, 0x2d26, 0],
	[0x2d27, 0x2d27, CM_LETTER],
	[0x2d28, 0x2d2c, 0],
	[0x2d2d, 0x2d2d, CM_LETTER],
	[0x2d2e, 0x2d2f, 0],
	[0x2d30, 0x2d67, CM_LETTER],
	[0x2d68, 0x2d6e, 0],
	[0x2d6f, 0x2d6f, CM_LETTER],
	[0x2d70, 0x2d7e, 0],
	[0x2d7f, 0x2d96, CM_LETTER],
	[0x2d97, 0x2d9f, 0],
	[0x2da0, 0x2da6, CM_LETTER],
	[0x2da7, 0x2da7, 0],
	[0x2da8, 0x2dae, CM_LETTER],
	[0x2daf, 0x2daf, 0],
	[0x2db0, 0x2db6, CM_LETTER],
	[0x2db7, 0x2db7, 0],
	[0x2db8, 0x2dbe, CM_LETTER],
	[0x2dbf, 0x2dbf, 0],
	[0x2dc0, 0x2dc6, CM_LETTER],
	[0x2dc7, 0x2dc7, 0],
	[0x2dc8, 0x2dce, CM_LETTER],
	[0x2dcf, 0x2dcf, 0],
	[0x2dd0, 0x2dd6, CM_LETTER],
	[0x2dd7, 0x2dd7, 0],
	[0x2dd8, 0x2dde, CM_LETTER],
	[0x2ddf, 0x2ddf, 0],
	[0x2de0, 0x2dff, CM_LETTER],
	[0x2e00, 0x2e2e, 0],
	[0x2e2f, 0x2e2f, CM_LETTER],
	[0x2e30, 0x2fff, 0],
	[0x3000, 0x3000, CM_WS | CM_WS_COLLAPSABLE],
	[0x3001, 0x3004, 0],
	[0x3005, 0x3006, CM_LETTER],
	[0x3007, 0x3007, CM_NUMBER],
	[0x3008, 0x3020, 0],
	[0x3021, 0x3029, CM_NUMBER],
	[0x302a, 0x302f, CM_LETTER],
	[0x3030, 0x3030, 0],
	[0x3031, 0x3035, CM_LETTER],
	[0x3036, 0x3037, 0],
	[0x3038, 0x303a, CM_NUMBER],
	[0x303b, 0x303c, CM_LETTER],
	[0x303d, 0x3040, 0],
	[0x3041, 0x3096, CM_LETTER],
	[0x3097, 0x3098, 0],
	[0x3099, 0x309a, CM_LETTER],
	[0x309b, 0x309c, 0],
	[0x309d, 0x309f, CM_LETTER],
	[0x30a0, 0x30a0, 0],
	[0x30a1, 0x30fa, CM_LETTER],
	[0x30fb, 0x30fb, 0],
	[0x30fc, 0x30ff, CM_LETTER],
	[0x3100, 0x3104, 0],
	[0x3105, 0x312f, CM_LETTER],
	[0x3130, 0x3130, 0],
	[0x3131, 0x318c, CM_LETTER],
	[0x318d, 0x318d, 0],
	[0x318e, 0x318e, CM_LETTER],
	[0x318f, 0x3191, 0],
	[0x3192, 0x3195, CM_NUMBER],
	[0x3196, 0x319f, 0],
	[0x31a0, 0x31bf, CM_LETTER],
	[0x31c0, 0x31ef, 0],
	[0x31f0, 0x31ff, CM_LETTER],
	[0x3200, 0x321f, 0],
	[0x3220, 0x3229, CM_NUMBER],
	[0x322a, 0x3247, 0],
	[0x3248, 0x324f, CM_NUMBER],
	[0x3250, 0x3250, 0],
	[0x3251, 0x325f, CM_NUMBER],
	[0x3260, 0x327f, 0],
	[0x3280, 0x3289, CM_NUMBER],
	[0x328a, 0x32b0, 0],
	[0x32b1, 0x32bf, CM_NUMBER],
	[0x32c0, 0x33ff, 0],
	[0x3400, 0x4dbf, CM_LETTER],
	[0x4dc0, 0x4dff, 0],
	[0x4e00, 0xa48c, CM_LETTER],
	[0xa48d, 0xa4cf, 0],
	[0xa4d0, 0xa4fd, CM_LETTER],
	[0xa4fe, 0xa4ff, 0],
	[0xa500, 0xa60c, CM_LETTER],
	[0xa60d, 0xa60f, 0],
	[0xa610, 0xa61f, CM_LETTER],
	[0xa620, 0xa629, CM_NUMBER],
	[0xa62a, 0xa62b, CM_LETTER],
	[0xa62c, 0xa63f, 0],
	[0xa640, 0xa672, CM_LETTER],
	[0xa673, 0xa673, 0],
	[0xa674, 0xa67d, CM_LETTER],
	[0xa67e, 0xa67e, 0],
	[0xa67f, 0xa6e5, CM_LETTER],
	[0xa6e6, 0xa6ef, CM_NUMBER],
	[0xa6f0, 0xa6f1, CM_LETTER],
	[0xa6f2, 0xa716, 0],
	[0xa717, 0xa71f, CM_LETTER],
	[0xa720, 0xa721, 0],
	[0xa722, 0xa788, CM_LETTER],
	[0xa789, 0xa78a, 0],
	[0xa78b, 0xa7dc, CM_LETTER],
	[0xa7dd, 0xa7f0, 0],
	[0xa7f1, 0xa827, CM_LETTER],
	[0xa828, 0xa82b, 0],
	[0xa82c, 0xa82c, CM_LETTER],
	[0xa82d, 0xa82f, 0],
	[0xa830, 0xa835, CM_NUMBER],
	[0xa836, 0xa83f, 0],
	[0xa840, 0xa873, CM_LETTER],
	[0xa874, 0xa87f, 0],
	[0xa880, 0xa8c5, CM_LETTER],
	[0xa8c6, 0xa8cf, 0],
	[0xa8d0, 0xa8d9, CM_NUMBER],
	[0xa8da, 0xa8df, 0],
	[0xa8e0, 0xa8f7, CM_LETTER],
	[0xa8f8, 0xa8fa, 0],
	[0xa8fb, 0xa8fb, CM_LETTER],
	[0xa8fc, 0xa8fc, 0],
	[0xa8fd, 0xa8ff, CM_LETTER],
	[0xa900, 0xa909, CM_NUMBER],
	[0xa90a, 0xa92d, CM_LETTER],
	[0xa92e, 0xa92f, 0],
	[0xa930, 0xa953, CM_LETTER],
	[0xa954, 0xa95f, 0],
	[0xa960, 0xa97c, CM_LETTER],
	[0xa97d, 0xa97f, 0],
	[0xa980, 0xa9c0, CM_LETTER],
	[0xa9c1, 0xa9ce, 0],
	[0xa9cf, 0xa9cf, CM_LETTER],
	[0xa9d0, 0xa9d9, CM_NUMBER],
	[0xa9da, 0xa9df, 0],
	[0xa9e0, 0xa9ef, CM_LETTER],
	[0xa9f0, 0xa9f9, CM_NUMBER],
	[0xa9fa, 0xa9fe, CM_LETTER],
	[0xa9ff, 0xa9ff, 0],
	[0xaa00, 0xaa36, CM_LETTER],
	[0xaa37, 0xaa3f, 0],
	[0xaa40, 0xaa4d, CM_LETTER],
	[0xaa4e, 0xaa4f, 0],
	[0xaa50, 0xaa59, CM_NUMBER],
	[0xaa5a, 0xaa5f, 0],
	[0xaa60, 0xaa76, CM_LETTER],
	[0xaa77, 0xaa79, 0],
	[0xaa7a, 0xaac2, CM_LETTER],
	[0xaac3, 0xaada, 0],
	[0xaadb, 0xaadd, CM_LETTER],
	[0xaade, 0xaadf, 0],
	[0xaae0, 0xaaef, CM_LETTER],
	[0xaaf0, 0xaaf1, 0],
	[0xaaf2, 0xaaf6, CM_LETTER],
	[0xaaf7, 0xab00, 0],
	[0xab01, 0xab06, CM_LETTER],
	[0xab07, 0xab08, 0],
	[0xab09, 0xab0e, CM_LETTER],
	[0xab0f, 0xab10, 0],
	[0xab11, 0xab16, CM_LETTER],
	[0xab17, 0xab1f, 0],
	[0xab20, 0xab26, CM_LETTER],
	[0xab27, 0xab27, 0],
	[0xab28, 0xab2e, CM_LETTER],
	[0xab2f, 0xab2f, 0],
	[0xab30, 0xab5a, CM_LETTER],
	[0xab5b, 0xab5b, 0],
	[0xab5c, 0xab69, CM_LETTER],
	[0xab6a, 0xab6f, 0],
	[0xab70, 0xabea, CM_LETTER],
	[0xabeb, 0xabeb, 0],
	[0xabec, 0xabed, CM_LETTER],
	[0xabee, 0xabef, 0],
	[0xabf0, 0xabf9, CM_NUMBER],
	[0xabfa, 0xabff, 0],
	[0xac00, 0xd7a3, CM_LETTER], // Hangul syllables
	[0xd7a4, 0xd7af, 0],
	[0xd7b0, 0xd7c6, CM_LETTER],
	[0xd7c7, 0xd7ca, 0],
	[0xd7cb, 0xd7fb, CM_LETTER],
	[0xd7fc, 0xd7ff, 0],
	[0xd800, 0xdfff, CM_SURROGATE], // Surrogate range
	[0xe000, 0xf8ff, 0],
	[0xf900, 0xfa6d, CM_LETTER],
	[0xfa6e, 0xfa6f, 0],
	[0xfa70, 0xfad9, CM_LETTER],
	[0xfada, 0xfaff, 0],
	[0xfb00, 0xfb06, CM_LETTER],
	[0xfb07, 0xfb12, 0],
	[0xfb13, 0xfb17, CM_LETTER],
	[0xfb18, 0xfb1c, 0],
	[0xfb1d, 0xfb28, CM_LETTER],
	[0xfb29, 0xfb29, 0],
	[0xfb2a, 0xfb36, CM_LETTER],
	[0xfb37, 0xfb37, 0],
	[0xfb38, 0xfb3c, CM_LETTER],
	[0xfb3d, 0xfb3d, 0],
	[0xfb3e, 0xfb3e, CM_LETTER],
	[0xfb3f, 0xfb3f, 0],
	[0xfb40, 0xfb41, CM_LETTER],
	[0xfb42, 0xfb42, 0],
	[0xfb43, 0xfb44, CM_LETTER],
	[0xfb45, 0xfb45, 0],
	[0xfb46, 0xfbb1, CM_LETTER],
	[0xfbb2, 0xfbd2, 0],
	[0xfbd3, 0xfd3d, CM_LETTER],
	[0xfd3e, 0xfd4f, 0],
	[0xfd50, 0xfd8f, CM_LETTER],
	[0xfd90, 0xfd91, 0],
	[0xfd92, 0xfdc7, CM_LETTER],
	[0xfdc8, 0xfdef, 0],
	[0xfdf0, 0xfdfb, CM_LETTER],
	[0xfdfc, 0xfdff, 0],
	[0xfe00, 0xfe0f, CM_LETTER],
	[0xfe10, 0xfe1f, 0],
	[0xfe20, 0xfe2f, CM_LETTER],
	[0xfe30, 0xfe32, 0],
	[0xfe33, 0xfe34, CM_LETTER],
	[0xfe35, 0xfe4c, 0],
	[0xfe4d, 0xfe4f, CM_LETTER],
	[0xfe50, 0xfe6f, 0],
	[0xfe70, 0xfe74, CM_LETTER],
	[0xfe75, 0xfe75, 0],
	[0xfe76, 0xfefc, CM_LETTER],
	[0xfefd, 0xfefe, 0],
	[0xfeff, 0xfeff, CM_WS | CM_WS_COLLAPSABLE],
	[0xff00, 0xff0f, 0],
	[0xff10, 0xff19, CM_NUMBER],
	[0xff1a, 0xff20, 0],
	[0xff21, 0xff3a, CM_LETTER],
	[0xff3b, 0xff3e, 0],
	[0xff3f, 0xff3f, CM_LETTER],
	[0xff40, 0xff40, 0],
	[0xff41, 0xff5a, CM_LETTER],
	[0xff5b, 0xff65, 0],
	[0xff66, 0xffbe, CM_LETTER],
	[0xffbf, 0xffc1, 0],
	[0xffc2, 0xffc7, CM_LETTER],
	[0xffc8, 0xffc9, 0],
	[0xffca, 0xffcf, CM_LETTER],
	[0xffd0, 0xffd1, 0],
	[0xffd2, 0xffd7, CM_LETTER],
	[0xffd8, 0xffd9, 0],
	[0xffda, 0xffdc, CM_LETTER],
	[0xffdd, 0xffff, 0],
] as const;

/** Build Uint16Array(65536) meta table at runtime (fast: range fill). */
function buildCharMetaTable(): Uint16Array {
	const meta = new Uint16Array(0x10000);
	for (let i = 0; i < RANGES.length; i++) {
		const [s, e, v] = RANGES[i];
		meta.fill(v, s, e + 1);
	}
	return meta;
}

export const CHAR_META = buildCharMetaTable();
